
import query from '@/gql/queries/components/techCard.gql';

const initialLines = [
  `__   ___ ___ ___
\\ \\ / __| _ ) _ \\
 \\ \\\\__ \\ _ \\  _/
  \\_\\___/___/_|`,
  'Schuberg Philis, system Security Interface',
  'Version 4.0.5, Alpha E',
  'Booting bootloader version 20210303-2be7c3e',
  'Mounted filesystem with ordered data mode.',
  'Started new career deamon.',
  'Ready...',
  'Enter help for a list of commands.',
];

export default {
  data() {
    return {
      consoleInput: '',
      booting: false,
      booted: false,
      visible: false,
      observer: null,
      lines: [],
      historyIndex: -1,
      currentDir: null,
      careers: [],
    };
  },
  async fetch() {
    const result = await this.$cms.query({
      query,
      variables: {
        site: this.$i18n.locale,
      },
    });
    this.careers = result?.careers || [];
  },
  computed: {
    possiblePaths() {
      return this.$router.options.routes.reduce((prev, { path, name }) => {
        if (
          !name.includes(`__${this.$i18n.locale}`) ||
          !path.includes('careers') ||
          path.includes('careers/:slug')
        ) {
          return prev;
        }

        const fixedPath = path.slice(4);

        if (name.includes('careerCategories')) {
          return [
            ...prev,
            fixedPath.replace(':slug', 'technology'),
            fixedPath.replace(':slug', 'business'),
            fixedPath.replace(':slug', 'support'),
          ];
        }
        return [...prev, fixedPath];
      }, []);
    },
    possibleRoutes() {
      const routes = {};

      this.possiblePaths.forEach((uri) => {
        const paths = uri.split('/');

        if (paths.length === 1 && routes[paths[0]]) {
          routes[paths[0]].index = uri;
          return;
        } else if (paths.length === 1) {
          routes[paths[0]] = { index: uri };
          return;
        }

        let currentPath = routes;
        for (let i = 0; i < paths.length; i++) {
          const path = paths[i];

          if (i === paths.length - 1) {
            currentPath[path] = uri;
            return;
          }

          if (!currentPath[path]) {
            currentPath[path] = {};
          }

          currentPath = currentPath[path];
        }
      });

      return routes;
    },
    history() {
      return this.lines.filter(({ role }) => role === 'usr').reverse();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.observer = new IntersectionObserver(([{ isIntersecting }]) => {
        this.visible = isIntersecting;
        if (isIntersecting && !this.booted && !this.booting) {
          this.boot();
        } else if (isIntersecting && this.booted) {
          this.$refs.input.focus();
        }
      });

      this.observer.observe(this.$refs.input);
    });
  },
  destroyed() {
    this.observer?.disconnect();
  },
  methods: {
    onKeyDown(e) {
      if (e.key === 'Tab') {
        e.preventDefault();
        this.autocomplete();
      } else if (this.booted && e.key === 'ArrowUp') {
        e.preventDefault();
        this.historyIndex = Math.min(
          this.history.length - 1,
          this.historyIndex + 1
        );
        this.consoleInput = this.history[this.historyIndex]?.line || '';
      } else if (this.booted && e.key === 'ArrowDown') {
        e.preventDefault();
        this.historyIndex = Math.max(-1, this.historyIndex - 1);
        this.consoleInput = this.history[this.historyIndex]?.line || '';
      } else if (this.booted && e.key === 'Enter') {
        this.historyIndex = -1;
      }
    },
    autocomplete() {
      const result = /^(?:sudo )?(cd|open) (.+)/.exec(this.consoleInput);
      if (result?.length > 2) {
        const output = [];
        const command = result[1];
        const input = result[2].replace(/^.\//, '');
        const inputPaths = input.split('/').filter((path) => path !== '.');

        let currentDir = this.currentDir;
        for (const path of inputPaths) {
          if (path) {
            const routesInDir = this.getRoutesInDir(currentDir);
            const cdDir = routesInDir[path];
            const routes = Object.keys(routesInDir);
            const route = routes.find((route) => route.startsWith(path));

            if (path === '..') {
              output.push(path);
              if (currentDir) {
                currentDir = currentDir.split('/').slice(0, -1).join('/');
              }
            } else if (cdDir && typeof cdDir === 'string') {
              output.push(path);
            } else if (cdDir && typeof cdDir === 'object') {
              output.push(path);
              currentDir = currentDir ? `${currentDir}/${path}` : path;
            } else if (route) {
              output.push(route);
            }
          } else {
            output.push('');
          }
        }

        if (output.length) {
          this.consoleInput = `${command} ${output.join('/')}`;
        }
      }
    },
    onSubmit() {
      if (!this.booted) return;

      const input = this.consoleInput.trim();
      this.consoleInput = '';

      this.lines.push({ cleared: false, role: 'usr', line: input });

      const response = this.getResponse(input);

      if (typeof response === 'function') response(this);
      else if (typeof response === 'string' && response) {
        this.lines.push({ cleared: false, role: 'sys', line: response });
      }
    },
    getRoutesInDir(startDir = this.currentDir) {
      if (!startDir) return this.possibleRoutes;

      const paths = startDir.split('/');
      let dir = this.possibleRoutes;
      for (const path of paths) {
        dir = dir[path];
      }
      return dir;
    },
    async boot() {
      let totalTimeout = 0;
      this.booting = true;

      await Promise.all(
        initialLines.map(
          (line) =>
            new Promise((resolve) => {
              const timeout = Math.floor(
                Math.random() * (1000 - 250 + 1) + 250
              );
              setTimeout(() => {
                this.lines.push({ cleared: false, role: 'sys', line });
                resolve();
              }, totalTimeout + timeout);
              totalTimeout += timeout;
            })
        )
      );

      this.booting = false;
      this.booted = true;
      if (this.visible) {
        this.$refs.input.focus();
      }
    },
    getResponse(input) {
      if (/^sudo (.*)/.test(input)) {
        return 'access denied: YOU DID NOT SAY THE MAGIC WORD!';
      }

      // list all commands
      if (input === 'help') return `help, clear, ls, cd, open`;

      // list all routes
      if (input === 'ls') {
        return Object.keys(this.getRoutesInDir()).forEach((line) => {
          this.lines.push({ cleared: false, role: 'sys', line });
        });
      }

      // open a route
      if (/^open(.*)/.test(input)) {
        const result = /^open (?:\.?\/)?(.+)/.exec(input);

        if (result?.length > 1) {
          const currentDir = this.getRoutesInDir();
          const route = currentDir[result[1]];

          if (route && typeof route === 'string') {
            this.$router.push(`/${this.$i18n.locale}/${route}`);
            return '';
          } else if (route && route.index) {
            this.$router.push(`/${this.$i18n.locale}/${route.index}`);
            return '';
          }

          if (route) {
            return `bash: open: this is a directory: ${result[1]}`;
          }

          return `bash: open: ${result[1]}: No such route`;
        }

        return '';
      }

      // change directory
      if (/^cd(.*)/.test(input)) {
        const result = /^cd (.+)/.exec(input);

        if (result && result[1]) {
          let currentDir = this.currentDir;
          const routes = result[1]
            .split('/')
            .filter((route) => route && route !== '.');

          for (const route of routes) {
            const routesInDir = this.getRoutesInDir(currentDir);
            const cdDir = routesInDir[route];

            if (route === '..') {
              if (currentDir) {
                currentDir = currentDir.split('/').slice(0, -1).join('/');
              }
            } else if (cdDir && typeof cdDir === 'string') {
              return `bash: cd: not a directory: ${route}`;
            } else if (cdDir && typeof cdDir === 'object') {
              currentDir = currentDir ? `${currentDir}/${route}` : route;
            } else {
              return `bash: cd: ${route}: No such route or directory`;
            }
          }

          this.currentDir = currentDir;
        }

        return '';
      }

      // clear console
      if (input === 'clear') {
        this.lines = this.lines.map((line) => ({ ...line, cleared: true }));
        return '';
      }

      return `bash: command not found: ${input}`;
    },
  },
};
